<template>
  <div>
    <b-modal id="modalFreezedService" ref="modalFreezedService" :title="$t('Freezed service')" hide-footer size="lg">
      <div v-if="editItem && (serviceType === 10)">
        <b-form-group label-align="right" :label="$t('Full name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.service_data.service_name" aria-describedby="inputFeedbackName" :state="editItem.service_data.service_name.length > 0"/>
          <b-form-invalid-feedback id="inputFeedbackName">
            {{ $t('Enter title') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="text" v-model="editItem.service_data.comment"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Cost')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input type="number" v-model="editItem.freezed_service_data.cost" aria-describedby="inputFeedbackCost" :state="editItem.freezed_service_data.cost !== ''"/>
          <b-form-invalid-feedback id="inputFeedbackCost">
            {{ $t('Enter cost') }}
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Charge type')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select required :options="chargeTypeAction" v-model="editItem.freezed_service_data.charge_type_action"></b-form-select>
        </b-form-group>

        <modal-ok-cancel @save="saveFreezedService" @cancel="$refs.modalFreezedService.hide" size="lg"/>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    isEdit: null,
    editItem: null,
    serviceType: null
  },
  data () {
    return {
      chargeTypeAction: [
        {value: 0, text: this.$t('Charge on expiration')},
        {value: 1, text: this.$t('Repay on expiration')},
        {value: 4, text: this.$t('Keep freezed')}
      ]
    }
  },
  methods: {
    saveFreezedService () {
      if (!this.editItem.service_data.service_name) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Full name fields is invalid'), 'Error')
        return
      }
      this.editItem.freezed_service_data.cost = Number(this.editItem.freezed_service_data.cost)
      let response = this.isEdit
        ? this.$store.dispatch('Tariffing/UPDATE_FREEZED_SERVICE', this.editItem)
        : this.$store.dispatch('Tariffing/CREATE_FREEZED_SERVICE', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_SERVICES')
          this.$refs.modalFreezedService.hide()
          this.$root.$emit('makeToasts')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formFreezedService.vue